import { render, staticRenderFns } from "./BFormInputRut.vue?vue&type=template&id=787838d2&"
import script from "./BFormInputRut.vue?vue&type=script&lang=js&"
export * from "./BFormInputRut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('787838d2')) {
      api.createRecord('787838d2', component.options)
    } else {
      api.reload('787838d2', component.options)
    }
    module.hot.accept("./BFormInputRut.vue?vue&type=template&id=787838d2&", function () {
      api.rerender('787838d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inputs/BFormInputRut.vue"
export default component.exports